import MainLayout from "./main";
import { Outlet } from "react-router-dom";

export default function LayoutWrapper() {
    return (
        <MainLayout>
            <Outlet />
        </MainLayout>
    );
}
